<template>
  <div class="module-container providers-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <div
          class="
            main-image-container
            bg-purple
            rounded
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <img
            height="30"
            width="30"
            :src="require('../../assets/icons/doctor.svg')"
          />
        </div>
        <h3 class="mb-0 ml-3">Providers</h3>
      </div>
      <b-button
        class="button-primary-shadow"
        size="md"
        @click="addProvider"
        variant="primary"
        >New Provider</b-button
      >
    </div>

    <div class="filters-container" ref="filtersContainer">
      <div
        class="
          d-flex
          flex-row
          justify-content-between
          align-items-center
          bg-light-gray
          min-width-fit-content
        "
      >
        <div class="d-flex flex-wrap align-items-center">
          <b-form-input
            class="auth-input search-input border-color-light-gray"
            v-model="filter.searchPhrase"
            placeholder="Search Providers..."
            :readonly="searchingProvider"
          />
          <span class="ml-4 mr-3" style="font-size: 14px">Active filters:</span>

          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-if="filter.searchPhrase.length >= 3"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Search Bar:
                <span class="color-filter">{{
                  filter.searchPhrase
                }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="filter.searchPhrase = ''"
              ></i>
            </div>
          </div>

          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(s, sIndex) in filter.supervisor"
            :key="s.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Supervisor:
                <span class="color-filter">{{
                  s.label.length > 50
                    ? s.label.substr(0, 50).concat(`...`)
                    : s.label
                }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeSupervisorFormFilter(sIndex)"
              ></i>
            </div>
          </div>

          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(n, mIndex) in filter.manager"
            :key="n.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Manager:
                <span class="color-filter">{{
                  n.label.length > 50
                    ? n.label.substr(0, 50).concat(`...`)
                    : n.label
                }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeManagerFormFilter(mIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(n, mIndex) in filter.placeOfService"
            :key="n.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Place of Service:
                <span class="color-filter">{{
                  n.label.length > 50
                    ? n.label.substr(0, 50).concat(`...`)
                    : n.label
                }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removePlaceOfServiceFilter(mIndex)"
              ></i>
            </div>
          </div>
          <span
            v-show="hasFilters"
            class="clear-all-filters text-danger ml-2"
            style="font-size: 14px"
            @click="clearAllFilters"
            >Clear all filters</span
          >
        </div>
        <div class="d-flex align-self-stretch align-items-center">
          <div class="align-self-stretch" style="padding: 9px 0px">
            <div class="vertical-separator border-med-light-gray"></div>
          </div>

          <b-dropdown
            id="dropdown-form"
            text="Filters"
            ref="filterDropdown"
            class="container-main bg-light-gray"
            toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
            menu-class="container-filter-main-menu"
            toggle-tag="div"
            boundary="window"
            right
            @hide="onFilterHide"
          >
            <template #button-content>
              <div class="d-flex align-items-center mr-2">
                <i
                  class="fas fa-filter mr-2"
                  :class="hasFilters ? 'text-primary' : ''"
                  style="font-size: 15px"
                  aria-hidden="true"
                ></i>
                <span style="font-size: 14px">Add Filter</span>
              </div>
            </template>
            <b-dropdown-form class="px-2">
              <b-form-group label="Filter by:">
                <b-form-select
                  v-model="selectedFilter"
                  :options="filterOptions"
                />
              </b-form-group>

              <multiple-select-filter
                v-if="selectedFilter == 'supervisor'"
                v-model="filter.supervisor"
                :label="'Supervisor'"
                :options="supervisorOptions"
                :width="filterWidth"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'supervisor'"
                ref="supervisorFilter"
              />

              <multiple-select-filter
                v-if="selectedFilter == 'manager'"
                v-model="filter.manager"
                :label="'Manager'"
                :options="managerOptions"
                :width="filterWidth"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'manager'"
                ref="managerFilter"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'placeOfService'"
                v-model="filter.placeOfService"
                :label="'Manager'"
                :options="placesOfServiceOptions"
                :width="filterWidth"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'placeOfService'"
                ref="placeOfService"
              />
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="mt-3 mb-0 w-100 d-flex flex-row justify-content-end">
      <div class="d-flex flex-row justify-content-end align-items-right">
        <top-paginator
          :total="listTotal"
          :page="filter.page"
          :perPage="filter.pageSize"
          @change-page="changePage"
        />
      </div>
    </div>

    <div
      :style="
        `--document-list-filters-container-height:calc(${filtersContainerHeight}px);`
      "
    >
      <grid
        ref="grid"
        :columns="columns"
        :data="items"
        :store="gridConfig.store"
        :selectionMode="gridConfig.selectionMode"
        :columnLines="gridConfig.columnLines"
        :groupFeature="false"
        :searchFeature="true"
        :stripeFeature="false"
        @storesort="listeners.storeSort"
        @renderrows="hookDropdownButtons"
        @renderrow="hookDropdownButtons"
      />

      <add-or-edit-providers-view-modal
        v-if="providersViewModal.show"
        v-model="providersViewModal.show"
        @onModify="onAddOrEditProviders"
        :providerId="providersViewModal.id"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import TopPaginator from "../controls/TopPaginator.vue";
import AddOrEditProvidersViewModal from "./ProvidersAddEditModal.vue";
import providersServer from "../../server/providers";
import supervisionServer from "../../server/supervision";
import userServer from "../../server/user";

export default {
  name: "ProvidersIndex",
  components: {
    Grid,
    TopPaginator,
    AddOrEditProvidersViewModal
  },
  props: ["showing"],
  data() {
    const self = this;
    return {
      list: [],
      listTotal: 0,

      filterWidth: "250px",
      filterPatientWidth: "350px",
      selectedFilter: "supervisor",
      filterOptions: [
        {
          value: "supervisor",
          text: "Supervisor"
        },
        {
          value: "manager",
          text: "Manager"
        },
        {
          value: "placeOfService",
          text: "Place of Service"
        }
      ],
      filter: {
        searchPhrase: "",
        page: 0,
        pageSize: 50,
        supervisor: [],
        manager: [],
        placeOfService: [],
        startDateTime: null,
        endDateTime: null,
        orderBy: "fullName",
        orderByDescending: false
      },
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: false,
          checkbox: false,
          rowCheckboxSelection: false,
          showCheckAll: false
        },
        columnLines: false,
        store: {
          // Default sorters
          sorters: [{ field: "fullName", ascending: true }]
        }
      },
      showResults: false,
      showAddFileEditor: false,
      providersViewModal: {
        show: false,
        id: null
      },
      users: [],
      supervisorOptions: [],
      managerOptions: [],
      lastTimeoutProviderOptions: null,
      lastTimeoutServiceOptions: null,
      searchingProvider: false,
      searchingSupervisor: false,
      searchingManager: false,
      filtersContainerHeight: 0,
      filterTextSelection: null,
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      },
      currentFetchProviderTimeoutId: null
    };
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "fetchCurrentUser"]),
    ...mapActions("client", ["fetchPlacesOfService"]),
    async fetchInitialData() {
      this.fetchSupervisorOptions();
      this.fetchManagerOptions();

      this.searchProviders(false);
    },
    searchProviders(delayed = true) {
      if (delayed) {
        if (this.lastTimeout) {
          clearTimeout(this.lastTimeout);
          this.lastTimeout = null;
        }
        this.lastTimeout = setTimeout(async () => {
          this.fetchProviders();
        }, 1000);
      } else this.fetchProviders();

      this.showResults = true;
    },
    async fetchProviders() {
      const result = await providersServer.query({
        searchPhrase:
          this.filter.searchPhrase.length >= 3 ? this.filter.searchPhrase : "",
        page: this.filter.page,
        pageSize: this.filter.pageSize,
        orderBy: this.filter.orderBy,
        orderByDescending: this.filter.orderByDescending,

        supervisor: this.filter.supervisor.map(x => x.value),
        manager: this.filter.manager.map(x => x.value),
        placeOfService: this.filter.placeOfService.map(x => x.value)
      });
      this.list = result.providers;
      this.listTotal = result.count;
    },
    scrollGridToTop() {
      const grid = document.querySelector(".documents-container .b-grid");
      grid.scrollTop = 0;
    },

    async fetchSupervisorOptions(search = "") {
      if (this.lastTimeoutSearch) {
        clearTimeout(this.lastTimeoutSearch);
        this.lastTimeoutSearch = null;
      }
      this.lastTimeoutSearch = await setTimeout(async () => {
        var filterType = {
          filter: "usersInSupervisionChart",
          userId: null,
          searchPhrase: search
        };
        const supervisionUsers = await supervisionServer.getSupervisionChartUsers(
          filterType
        );
        this.supervisorOptions = supervisionUsers.map(supervisionUser => ({
          value: supervisionUser.id,
          label: supervisionUser.firstName + " " + supervisionUser.lastName
        }));
      }, 1000);
    },
    async fetchManagerOptions(search = "") {
      if (this.lastTimeoutSearch) {
        clearTimeout(this.lastTimeoutSearch);
        this.lastTimeoutSearch = null;
      }
      this.lastTimeoutSearch = await setTimeout(async () => {
        const users = await userServer.getFilteredManagers({
          SearchPhrase: search
        });
        this.managerOptions = users.map(user => ({
          value: user.id,
          label: user.firstName + " " + user.lastName
        }));
      }, 1000);
    },
    updateFilterOptions() {
      this.fetchSupervisorOptions();
      this.fetchManagerOptions();
    },
    onFilterHide(event) {
      let ref = null;
      if (this.selectedFilter == "supervisor") {
        ref = this.$refs.supervisorFilter;
      }
      if (this.selectedFilter == "manager") {
        ref = this.$refs.managerFilter;
      }

      if (this.filterTextSelection) {
        if (this.filterTextSelection) event.preventDefault();
        ref.highlightText();
        this.filterTextSelection = null;
      }
    },
    changePage(page) {
      this.filter.page = page;
      this.fetchProviders();
      this.scrollGridToTop();
    },
    updatePopper() {
      this.$refs.filterDropdown.updatePopper();
    },
    computeHeights() {
      setTimeout(() => {
        const filtersContainerHeight = this.$refs.filtersContainer.clientHeight;
        this.filtersContainerHeight = filtersContainerHeight;
      }, 0);
    },
    updateTextSelection(textSelection) {
      this.filterTextSelection = textSelection;
    },
    onAddOrEditProviders() {
      this.providersViewModal = {
        show: false,
        id: null
      };
      this.fetchInitialData();
      this.fetchCurrentUser();
    },
    addProvider() {
      this.providersViewModal = {
        show: true,
        id: null
      };
    },
    clearAllFilters() {
      this.filter.searchPhrase = "";
      this.filter.supervisor = [];
      this.filter.manager = [];
      this.filter.placeOfService = [];
    },
    removeSupervisorFormFilter(index) {
      const newValue = [...this.filter.supervisor];
      newValue.splice(index, 1);
      this.filter.supervisor = newValue;
    },
    removeManagerFormFilter(index) {
      const newValue = [...this.filter.manager];
      newValue.splice(index, 1);
      this.filter.manager = newValue;
    },
    removePlaceOfServiceFilter(index) {
      const newValue = [...this.filter.placeOfService];
      newValue.splice(index, 1);
      this.filter.placeOfService = newValue;
    },
    inputDebounce(currentTimeoutId, callback) {
      if (currentTimeoutId) {
        clearTimeout(currentTimeoutId);
      }

      return setTimeout(() => {
        callback();
      }, 700);
    },
    providerSearchDebounce() {
      this.currentFetchProviderTimeoutId = this.inputDebounce(
        this.currentFetchProviderTimeoutId,
        this.fetchProviders
      );
    }
  },
  computed: {
    ...mapState("layout", {
      organizationName: state => state.systemSetting.organizationName,
      organizationId: state => state.systemSetting.id
    }),
    items() {
      return this.list.map(item => {
        return {
          ...item
        };
      });
    },
    columns() {
      const self = this;
      return [
        {
          text: "Name",
          field: "fullName",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.firstName + " " + data.record.data.lastName,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Credentials",
          field: "credentials",
          type: "template",
          width: 100,
          editor: false,
          template: data => data.record.data.credential?.name ?? "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "NPI",
          field: "npi",
          type: "template",
          flex: 1,
          editor: false,
          template: data => data.record.data.npi,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Email",
          field: "email",
          type: "template",
          width: 250,
          editor: false,
          template: data => data.record.data.email,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Mobile Phone",
          field: "phone",
          type: "template",
          flex: 1,
          editor: false,
          template: data => data.record.data.phone,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Manager",
          field: "manager",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.managerFullName
              ? data.record.data.managerFullName
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Supervisor",
          field: "supervisor",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.supervisorUserFullName
              ? data.record.data.supervisorUserFullName
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Places of Service",
          type: "template",
          flex: 4,
          editor: false,
          autoHeight: true,
          template: data =>
            data.record.data.placeOfServices?.length > 0
              ? `<div class="text-wrap" style="height: 100%;
                                               padding: 10px 5px;
                                               display: flex;
                                               align-items: center;">
                  <div style="max-height: 100%;
                              overflow-y: auto;
                              padding-right: 10px;">` +
                data.record.data.placeOfServices
                  .sort((a, b) => {
                    return a.name.localeCompare(b.name);
                  })
                  .map(x => `${x.code}-${x.name}`)
                  .join(",") +
                `</div>
                </div>`
              : "",
          sortable: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          align: "right",
          width: 80,
          actions: [
            {
              tooltip: "More",
              renderer: ({ record }) => {
                const actions = [];
                actions.push({
                  content: "Edit",
                  callback: () => {
                    this.providersViewModal = {
                      show: true,
                      id: record.data.id
                    };
                  }
                });
                actions.push({
                  content: "Delete",
                  callback: () => {
                    this.$dialog
                      .alert(
                        {
                          title: "Are you sure you want to delete this record?"
                        },
                        {
                          view: "confirm-delete"
                        }
                      )
                      .then(async () => {
                        let result = null;
                        result = await providersServer.removeProvider(
                          record.data.id
                        );
                        if (result.errorCode) {
                          this.$dialog.alert("Error: " + result.message);
                        } else {
                          this.fetchInitialData();
                          this.showAlertSuccess();
                        }
                      });
                  }
                });
                return this.createDropdownButton({
                  items: actions
                });
              }
            }
          ]
        }
      ];
    },
    hasFilters() {
      return (
        this.filter.searchPhrase.length > 0 ||
        this.filter.supervisor.length > 0 ||
        this.filter.manager.length > 0 ||
        this.filter.placeOfService.length > 0
      );
    },
    pageSize: {
      get() {
        return this.filter.pageSize.toString();
      },
      set(newValue) {
        this.filter.pageSize = parseInt(newValue);
        this.changePage(0);
      }
    },
    ...mapState("client", {
      placesOfServiceOptions: state =>
        state.placesOfService.map(placeOfService => ({
          value: placeOfService.id,
          label: `${placeOfService.code}-${placeOfService.name}`,
          data: placeOfService
        }))
    })
  },
  watch: {
    showing: function(newValue) {
      if (newValue) {
        this.fetchInitialData();
        this.computeHeights();
      }
    },
    "filter.searchPhrase": function() {
      this.filter.page = 0;
      if (
        this.filter.searchPhrase.length == 0 ||
        this.filter.searchPhrase.length >= 3
      ) {
        this.providerSearchDebounce();
      }
    },
    "filter.provider": function() {
      this.filter.page = 0;
      this.searchProviders();
      this.computeHeights();
    },
    "filter.supervisor": function() {
      this.filter.page = 0;
      this.searchProviders();
      this.computeHeights();
    },
    "filter.manager": function() {
      this.filter.page = 0;
      this.searchProviders();
      this.computeHeights();
    },
    "filter.placeOfService": function() {
      this.filter.page = 0;
      this.searchProviders();
      this.computeHeights();
    },
    selectedFilter: function(newValue) {
      if (newValue == "placeOfService") this.fetchPlacesOfService();
      this.$refs.filterDropdown.updatePopper();
    }
  }
};
</script>

<style scoped>
.container-main {
  height: 45px;
}
.b-dropdown-form:focus {
  outline: none !important;
}

.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.filter-title {
  font-size: 16px;
}
.admission-data {
  font-size: 13px;
}

.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}

.providers-container >>> .b-grid-header .b-checkbox {
  margin-left: -7px;
}
.providers-container >>> .file-result-row .b-checkbox-selection div {
  display: none;
}
.providers-container >>> .b-grid-container .b-container {
  max-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  );
  min-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  ) !important;
}
.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}
.color-filter {
  color: #909db8;
}

.providers-container >>> .b-action-cell .b-action-ct {
  display: flex;
  align-items: center;
  gap: 5px;
}
.placeOfServicesCell {
  display: flex;
  flex-direction: column;
}
.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  width: 320px;
}
</style>
